module.exports = __webpack_public_path__ + "static/img/Frame(4).c868c561.png";